(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var cartSection = document.querySelector('.eden-cart[data-money-format]');
    if (!cartSection) return;

    var moneyFormat = cartSection.dataset.moneyFormat || '£{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      // Handle Shopify money formats: {{amount}}, {{amount_with_comma_separator}}, etc.
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }

    function updateCartDOM(cart) {
      // Update each line item price and quantity
      cart.items.forEach(function(item) {
        var priceEl = document.querySelector('[data-line-price="' + item.key + '"]');
        var inputEl = document.querySelector('.eden-cart__qty-input[data-key="' + item.key + '"]');
        if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
        if (inputEl) inputEl.value = item.quantity;

        // Remove item row from DOM if quantity is 0
        if (item.quantity === 0) {
          var itemRow = document.querySelector('.eden-cart__item[data-key="' + item.key + '"]');
          if (itemRow) {
            var rule = itemRow.nextElementSibling;
            if (rule && rule.classList.contains('eden-cart__item-rule')) rule.remove();
            itemRow.remove();
          }
        }
      });

      // Update cart totals
      document.querySelectorAll('[data-cart-total]').forEach(function(el) {
        el.textContent = formatMoney(cart.total_price);
      });

      // Reload if cart is now empty
      if (cart.item_count === 0) window.location.reload();
    }

    function changeQuantity(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartDOM(cart); })
      .catch(function() { window.location.reload(); });
    }

    // Qty +/- buttons
    document.querySelectorAll('.eden-cart__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.key;
        var input = document.querySelector('.eden-cart__qty-input[data-key="' + key + '"]');
        if (!input) return;
        var val = parseInt(input.value, 10) || 0;
        var newVal = this.dataset.action === 'increment' ? val + 1 : Math.max(0, val - 1);
        input.value = newVal;
        changeQuantity(key, newVal);
      });
    });

    // Remove links — intercept and use AJAX instead of page reload
    document.querySelectorAll('.eden-cart__remove').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var item = this.closest('.eden-cart__item');
        if (!item) return;
        var key = item.dataset.key;
        changeQuantity(key, 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eden-product-main"]) return;
  try {
    
  (function() {
    var sectionId = '{{ section.id }}';
    var gallery = document.getElementById('ProductGallery-' + sectionId);
    if (!gallery) return;

    var slidesWrap = document.getElementById('MainImageWrap-' + sectionId);
    var slides = Array.from(gallery.querySelectorAll('.eden-product__main-img-slide'));
    var thumbs = Array.from(gallery.querySelectorAll('.eden-product__thumb'));
    var dots   = Array.from(gallery.querySelectorAll('.eden-product__dot'));

    function isDesktop() { return window.innerWidth >= 1024; }

    function syncControls(index) {
      thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function(d, i)   { d.classList.toggle('is-active', i === index); });
    }

    function goToSlide(index) {
      if (!slidesWrap) return;
      if (isDesktop()) {
        // Opacity toggle — no scroll needed
        slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
      } else {
        // Scroll-snap carousel
        slidesWrap.scrollTo({ left: index * slidesWrap.offsetWidth, behavior: 'smooth' });
      }
      syncControls(index);
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { goToSlide(i); });
    });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goToSlide(i); });
    });

    // Sync controls after mobile swipe
    if (slidesWrap) {
      var scrollTimer;
      slidesWrap.addEventListener('scroll', function() {
        if (isDesktop()) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var idx = Math.round(slidesWrap.scrollLeft / slidesWrap.offsetWidth);
          syncControls(idx);
        }, 50);
      }, { passive: true });
    }

    // On resize, reset to first slide to avoid stale state
    window.addEventListener('resize', function() {
      goToSlide(0);
    }, { passive: true });

    // Quantity buttons
    var form = document.getElementById('ProductForm');
    if (form) {
      var qtyInput = form.querySelector('.eden-product__qty-input');
      form.querySelectorAll('.eden-product__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (this.dataset.action === 'increment') { qtyInput.value = val + 1; }
          else if (this.dataset.action === 'decrement' && val > 1) { qtyInput.value = val - 1; }
        });
      });

      var variantSelect = form.querySelector('#VariantSelect');
      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          form.querySelector('[name="id"]').value = this.value;
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    var scrolled = false;
    function onScroll() {
      var shouldScroll = window.scrollY > 10;
      if (shouldScroll !== scrolled) {
        scrolled = shouldScroll;
        header.classList.toggle('is-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  // Scroll-triggered fade-up animations
  (function() {
    var els = document.querySelectorAll('.fade-up');
    if (!els.length) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
